import { render, staticRenderFns } from "./relJinhengDialog3.vue?vue&type=template&id=482fbbab"
import script from "./relJinhengDialog3.vue?vue&type=script&lang=js"
export * from "./relJinhengDialog3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports